if (!customElements.get('s-main-collection')) {
  customElements.define('s-main-collection', class SectionMainCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.cacheElements()
        this.addEventListener("change", this.changeHandler)
        this.addEventListener("click", this.clickHandler)

        subscribe("filter-changer", this.inputChanger)
        subscribe("sort-changer", this.sortHandler)
      }

      disconnectedCallback() {
        this.removeEventListener("change", this.changeHandler)
        this.removeEventListener("click", this.clickHandler)
      }

      filterOpener = () => {
        publish("open-filter-modal")
      }

      cacheElements = () => {
        this.productList = this.querySelector(".js-main-collection__list");
        this.sort = this.querySelector(".js-main-collection__sort-wrapper");
        this.paginations = Array.from(this.querySelectorAll(".js-main-collection__pagination"));
        this.mobileContainer = this.querySelector(".js-main-collection__mobile-wrapper");
      }

      sortHandler = event => {
        let value = event.target.value;

        const url = new URL(window.location.href);
        const params = url.searchParams;
    
        if (params.has('sort_by')) {
            params.set('sort_by', value);
        } else {
            params.append('sort_by', value);
        }
    
        this.filterChangeHandler(`${url.pathname}?${params.toString()}`)
      }

      changeHandler = (event) => {
        if (event.target.closest(".js-main-collection__sort-select")) {
          this.sortHandler(event);
          return;
        }

        if (event.target.matches(".js-main-collection__filter-value input")) {
          this.inputChanger(event);
        }
      }

      clickHandler = (event) => {
        if (event.target.closest(".js-main-collection__modal-button")) {
          this.filterOpener()
        }
      }

      inputChanger = (event) => {
        let input = event.target
        let updatedUrl = input.checked ? input.dataset.filterAdd : input.dataset.filterRemove;

        if (!updatedUrl) return;

        this.classList.add("is-loading")
        this.filterChangeHandler(updatedUrl)
      }

      filterChangeHandler = (updatedUrl) => {
        fetch(updatedUrl)
        .then(res => res.text())
        .then(response => {
          let newDom = new DOMParser().parseFromString(response, "text/html");
          let newSection = newDom.querySelector("s-main-collection");
          if (!newSection) return;

          this.innerHTML = newSection.innerHTML;
          this.cacheElements()

          publish("update-filter", newDom)

          window.history.pushState(null, '', updatedUrl);
        })
        .finally(() => {
          this.classList.remove("is-loading")
        })
        .catch(error => {
          console.log(error)
        })
      }
    }
  );
}
